import { Text } from '@zillow/constellation';

export const SmallDropzone = () => (
  <Text as="div" marginTop="xs">
    Add
  </Text>
);
